module.exports = __webpack_public_path__ + "img/cultura6.0bdca763.png";